<template>
  <page-request v-if="level===1 || (level===2 && parentObj&&parentObj.id)" ref="table" url="/api/business/goodsClassify/list" :search-type="1"
                :table-header="tableHeader" position="center"
                :expend="expend" :prop="{type:type,parentId:parentObj&&parentObj.id,level:level}" :op-width="200">
    <t-button @click="doEdit()">添加</t-button>
    <template #before>
      <el-table-column label="名称" >
        <template #default="scope">
          <div @click="clickNode(scope.row)" class="cp primary-hover flex flex-ac">
            <img v-if="scope.row.iconUrl" :src="filePath+scope.row.iconUrl" :style="{width:'50px',height:'50px'}"/>
            {{scope.row.name}}
          </div>
        </template>
      </el-table-column>
    </template>
    <template #op="scope">
      <b-button @click="doEdit(scope.row)">编辑</b-button>
      <b-button v-show="scope.row.status===1" @click="updateStatus(scope.row.id,0)">禁用</b-button>
      <b-button v-show="scope.row.status===0" @click="updateStatus(scope.row.id,1)">启用</b-button>
      <b-button @click="doDel(scope.row.id)">删除</b-button>
    </template>
  </page-request>
  <empty-data-image v-else=""></empty-data-image>
  <add-classify ref="add" @load="pageReloadData"></add-classify>
</template>

<script>

import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import EmptyDataImage from "@/components/el/layout/empty-data-image.vue";
import AddClassify from "@view/components/classify/add-classify.vue";

export default {
  components: {AddClassify, EmptyDataImage, PageRequest, TButton, BButton},
  props:{
    type:{
      type:Number,
      default:0
    },
    parentObj:{
      type:Object,
    },
    level:{
      type:Number,
      default:1
    }
  },
  name: "classify-list",
  data() {
    return {
      tableHeader: [
        {prop: "sort", label: "排序",width:100},
        {label: "状态",renderDraw:row=>{
            return row.status?"正常":"禁用";
          },width: 100},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "名称", prop: "name"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    clickNode(row){
      this.$emit('click-node',row);
    },
    doEdit(row){
      this.$refs.add.open(row, this.type,this.level,this.parentObj);
    },
    updateStatus(id,status){
      this.msgConfirm("/api/business/goodsClassify/updateStatus",{id:id,status:status},()=>{
        this.pageReloadData();
      },`您是否要${status===1?'启用':'禁用'}所选分类?`)

    },
    doDel(id){
      this.msgConfirm("/api/business/goodsClassify/delete", {id: id}, () => {
        this.pageReloadData();
      });
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
